import React, { useState } from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import {
  ActionMenuDivider,
  ActionMenuItem,
  ActionsDropdownMenu,
} from './deep-links/ActionsDropdownMenu';
import { DoctorClinicBranch } from '../../models/MasterAdmin/doctorClinic';

interface ClinicBranchActionsMenuProps {
  branch: DoctorClinicBranch;
  timeslotCount: number;
  onDeleteTimeslots: (branch: DoctorClinicBranch) => void;
  onDeleteBranch: (branch: DoctorClinicBranch) => void;
}

const ClinicBranchActionsMenu: React.FC<ClinicBranchActionsMenuProps> = ({
  branch,
  timeslotCount,
  onDeleteTimeslots,
  onDeleteBranch,
}) => {
  const [open, setOpen] = useState(false);
  const hasTimeslots = timeslotCount > 0;

  return (
    <ActionsDropdownMenu open={open} onToggle={() => setOpen((v) => !v)} onClose={() => setOpen(false)}>
      {hasTimeslots && (
        <>
          <ActionMenuItem
            icon={<TrashIcon className="h-4 w-4 text-amber-600" />}
            label="Delete all timeslots"
            onClick={() => {
              setOpen(false);
              onDeleteTimeslots(branch);
            }}
          />
          <ActionMenuDivider />
        </>
      )}
      <ActionMenuItem
        icon={<TrashIcon className="h-4 w-4" />}
        label="Delete clinic"
        tone="danger"
        onClick={() => {
          setOpen(false);
          onDeleteBranch(branch);
        }}
      />
    </ActionsDropdownMenu>
  );
};

export default ClinicBranchActionsMenu;
